export default class Currencies {
  static readonly EUR = { value: "EUR", text: "Euro - €", display: "€" };
  static readonly CHF = { value: "CHF", text: "Franc suisse - CHF", display: "CHF" };
  static readonly USD = { value: "USD", text: "Dollar US - $", display: "$" };
  static readonly CAD = { value: "CAD", text: "Dollar canadien - $CAD", display: "$" };
}
